export const formatAmount = (value: any) => (
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value)
);
